import { Injectable } from '@angular/core';
import { CurrencyFunctionalityService } from './currency-functionality.service';

@Injectable({
  providedIn: 'root'
})
export class FundsFunctionalityService {

  constructor() { }

  public static calculateTotalFund(fundsArray): number {
    let totalFund = 0;
    fundsArray.forEach(element => {
      totalFund += CurrencyFunctionalityService.convertCurrencyToNumber(element['fundValue']);
    });
    return totalFund;
  }
}
